var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70312 4.10938C7.70312 3.67773 8.03516 3.3125 8.5 3.3125C8.93164 3.3125 9.29688 3.67773 9.29688 4.10938V8.22656L12.1191 10.0859C12.4844 10.3516 12.584 10.8496 12.3184 11.2148C12.0859 11.5801 11.5879 11.6797 11.2227 11.4141L8.03516 9.28906C7.83594 9.15625 7.70312 8.89062 7.70312 8.625V4.10938ZM8.5 0.125C13.1816 0.125 17 3.94336 17 8.625C17 13.3398 13.1816 17.125 8.5 17.125C3.78516 17.125 0 13.3398 0 8.625C0 3.94336 3.78516 0.125 8.5 0.125ZM1.59375 8.625C1.59375 12.4434 4.68164 15.5312 8.5 15.5312C12.2852 15.5312 15.4062 12.4434 15.4062 8.625C15.4062 4.83984 12.2852 1.71875 8.5 1.71875C4.68164 1.71875 1.59375 4.83984 1.59375 8.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.cd0790c62db63c9dd77632da735e56ec.svg";
export { ForwardRef as ReactComponent };